export default __webpack_public_path__ + "static/media/Destination4.82f14e67.png";